import { Typography } from '@mui/material';
import MuiBox from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Input from '../../../Input/Input.js';

const PROPS = ['error', 'warning', 'disabled', 'size', 'inactive', 'displayAsPlaceholder', 'open'];
const getColor = (options) => {
    if (options.disabled) {
        return 'N40';
    }
    else if (options.error) {
        return 'error';
    }
    else if (options.warning) {
        return 'warning';
    }
    else if (options.displayAsPlaceholder) {
        return 'N30';
    }
    else if (options.inactive) {
        return 'N20';
    }
    else {
        return 'N10';
    }
};
const Root = styled(MuiBox, {
    shouldForwardProp: prop => !PROPS.includes(prop),
}) `
  position: relative;
  ${({ disabled }) => disabled &&
    `
    &:active {
      pointer-events: none;
    }
    &:hover {
      cursor: not-allowed;
    }
  `}
  ${({ theme, disabled, error, warning }) => !disabled &&
    !error &&
    !warning &&
    `
    &:hover svg path {
      fill: ${theme.palette.primary.main};
    }
    &:focus-within svg path {
      fill: ${theme.palette.primary.main};
    }
  `};
  svg {
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    z-index: 2;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    transition: opacity ${({ theme }) => theme.transitions.duration.fast} linear;
    ${({ theme, inactive, error, open, warning }) => `
      color: ${theme.palette[open ? 'primary' : getColor({ error, inactive, warning })].main};
    `}
    ${({ disabled, theme }) => disabled &&
    `
        path {
          fill: ${theme.palette.N30.main};
        }
    `};
  }
`;
const getPadding = (theme, size) => {
    switch (size) {
        case 'small':
            return theme.spacing(0.5, 1);
        case 'medium':
            return theme.spacing(1.75, 2);
        case 'large':
            return theme.spacing(2.25, 2);
    }
};
const PickerInput = styled(Input, {
    shouldForwardProp: prop => !['open'].includes(prop),
}) `
  &.MuiInput-input {
    padding: unset;
  }
  input::placeholder {
    opacity: 1;
  }
  width: 100%;
  ${({ theme, size }) => `padding: ${getPadding(theme, size)} !important`};
  &::selection {
    background-color: transparent;
    color: ${({ theme }) => theme.palette.N30.main};
    font-style: italic;
  }
  &:hover {
    input::placeholder {
      color: ${({ theme }) => theme.palette.primary.dark};
    }
  }
  &:focus-within {
    input::placeholder {
      color: ${({ theme }) => theme.palette.N30.main};
    }
  }
  ${({ theme, open, error }) => open &&
    !error &&
    `
    &:before {
      border-color: ${theme.palette.primary.main} !important;
    }
    &::placeholder {
      color: ${theme.palette.N30.main} !important;
    }
  `};
  ${({ size }) => size === 'large' &&
    `
    font-family: 'opensans-italic';
    font-size: 12px;
    letter-spacing: 0px;
    .MuiInput-input {
      font-size: 12px;
      font-family: 'opensans-regular';
      &::placeholder {
        font-size: 12px;
        font-family: 'opensans-regular';
      }
    },
  `};
`;
const Label = styled(Typography, {
    shouldForwardProp: prop => !PROPS.includes(prop),
}) `
  transition: all ${({ theme }) => theme.transitions.duration.fast} linear;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  cursor: text;
  z-index: 1;
  border-radius: 4px;
  cursor: pointer;
  line-height: 17px;
  ${({ hidden }) => hidden && `display: none`};
  padding: ${({ theme, size }) => getPadding(theme, size)};
  background-color: ${({ theme, inactive }) => theme.palette[inactive ? 'N80' : 'N70'].main};
  color: ${({ theme, disabled, error, inactive, displayAsPlaceholder, warning }) => theme.palette[getColor({ displayAsPlaceholder, disabled, error, inactive, warning })].main};
  &:hover {
    background-color: ${({ theme }) => theme.palette.N60.main};
  }
  ${({ theme, error, displayAsPlaceholder }) => !error &&
    `
    &:hover {
      color: ${theme.palette.primary[displayAsPlaceholder ? 'dark' : 'main']};
    }
  `};
  ${({ theme, disabled }) => disabled &&
    `
    cursor: not-allowed;
    background-color: ${theme.palette.N80.main};
    &:hover {
      background-color: ${theme.palette.N80.main};
      color: ${theme.palette.N40.main};
    }
  `};
`;

export { Label, PickerInput, Root };
//# sourceMappingURL=styled.js.map
